import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import MaterialTable from 'material-table';
import { Alert, Button, ButtonToolbar, Collapse } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Dialog, IconButton, Tooltip } from '@material-ui/core';
import SmartCard from '../../../shared/components/SmartCard';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import Select from '../../../shared/components/form/Select';
import renderField from '../../../shared/components/form/RenderField';
import { percentageMasker } from '../../../shared/components/form/Masks';
import { formatPhone } from '../../../shared/utils/smartutils';
import { columnsComposition, columnsGenerate } from './ColumnsGeneratorTitles';
import DiscontConfigurationForm from '../../AccountsReceivableAndPayable/components/receivable/DiscontConfiguration';
import FullScreenDialog from '../../../shared/components/FullScreenDialog';
import ViewDiscountComponent from './ViewDiscount';
import validate from './Validate';
import SmartContext from '../../App/context/SmartContext';
import { SMART_BABY_USER } from '../../../shared/utils/constants';
import materialTableIcons from '../../../shared/utils/materialTableIcons';
import MaterialTableThemeProvider from '../../../shared/components/MaterialTableThemeProvider';

const GeneratorTitles = (props) => {
  const {
    t,
    initialize,
    dto,
    titles,
    dispatch,
    categories,
    discountConfigurations,
    setDiscountConfigurations,
    loadDiscountConfigurationByAccount,
    accounts,
    smartpayConfigurations,
    handleSubmit,
  } = props;

  const context = useContext(SmartContext);
  const { loggedUser } = context;
  const [fullViewDiscount, setFullViewDiscount] = useState(false);
  const [viewDiscount, setViewDiscount] = useState([]);
  const [data, setData] = useState([]);
  const [compositionTitle, setCompositionTitle] = useState([]);
  const [isSmartPay, setIsSmartpay] = useState(false);
  const [hideChecked, setHideChecked] = useState(false);
  const [hideDiscount, setHideDiscount] = useState(false);
  const [hideSelect, setHideSelect] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(true);
  const [dialog, setDialog] = useState(false);
  const [generateTitlesDialogMessage, setGenerateTitlesDialogMessage] =
    useState({});
  const [discontConfigurationForm, setDiscontConfigurationForm] =
    useState(false);
  const [notificationAlert, setNotificationAlert] = useState({
    status: false,
    title: '',
    color: '',
  });
  const [applyDiscountConfigurations, setApplyDiscountConfigurations] =
    useState(false);

  const accountChange = (values) => {
    if (values.smartpay) {
      setIsSmartpay(true);
    }
    loadDiscountConfigurationByAccount(values.id);
    setSelectedAccount(true);
  };

  const accountChecboxChange = (value) => {
    if (!value) {
      setIsSmartpay(false);
      setSelectedAccount(!selectedAccount);
    } else {
      loadDiscountConfigurationByAccount(smartpayConfigurations.account.id);
      setIsSmartpay(true);
      setSelectedAccount(true);
    }
  };

  const compositionTitleChange = (rowData) => {
    const composition = [rowData].map((item) =>
      item.products.map((prod) => ({
        category: prod.category.name,
        value: rowData.value * prod.percentageOfTotal,
        dueDate: item.dueDate,
        quota:
          prod.numberInstallment && prod.numberInstallments
            ? `${prod.numberInstallment}/${prod.numberInstallments}`
            : null,
      }))
    );
    setCompositionTitle(composition[0]);
  };

  const onUpdateState = (rowData, newData) => {
    const updatedTitles = data.slice();
    const itemIndex = updatedTitles.indexOf(rowData);
    const dataToUpdate = {
      ...newData,
    };
    updatedTitles[itemIndex] = dataToUpdate;
    const selectedTitles = updatedTitles.filter((title) => title.generate);
    let numParc = 0;
    const updatedToTitles = updatedTitles.map((title1) => {
      const updatedProducts = title1.products.map((prod) => ({
        ...prod,
        value: title1.value * prod.percentageOfTotal,
      }));
      const find = selectedTitles.find((title2) => title1 === title2);
      const totalParc = selectedTitles.length;
      if (find) {
        numParc += 1;
        return {
          ...title1,
          quota: `${numParc}/${totalParc}`,
          products: [...updatedProducts],
        };
      }
      return { ...title1, quota: '-/-', products: [...updatedProducts] };
    });
    setData(updatedToTitles);
    change('titles', updatedToTitles);
    const rowUpdated = updatedToTitles.find(
      (title) => title.tableData.id === newData.tableData.id
    );
    compositionTitleChange(rowUpdated);
  };

  const toggleViewDiscount = () => {
    setFullViewDiscount(!fullViewDiscount);
  };

  const onViewDiscount = (rowData) => {
    setViewDiscount(rowData);
    toggleViewDiscount();
  };

  const toggleDiscontConfigurationForm = () => {
    setDiscontConfigurationForm(!discontConfigurationForm);
  };

  const changeDiscountConfigurations = (list, changed) => {
    if (changed) {
      setDiscountConfigurations(list);
      change('updateDiscount', changed);
    }
    let apply = false;
    if (list.length) {
      apply = true;
    }
    dispatch(change('generatorTitle', 'applyDiscountConfiguration', apply));
    toggleDiscontConfigurationForm();
  };

  const onShowAlert = (color, title, message) => {
    setNotificationAlert({
      ...notificationAlert,
      status: true,
      title,
      color,
      message,
    });
    window.setTimeout(() => {
      setNotificationAlert({
        ...notificationAlert,
        status: false,
        title: '',
        color: '',
        message: '',
      });
    }, 5000);
  };

  const toggleDialog = () => {
    setDialog(!dialog);
  };

  const handleSubmitGenerate = () => {
    const generate = data.filter((item) => item.generate);
    if (selectedAccount) {
      if (generate.length !== 0) {
        const totalValue = generate.reduce(
          (total, title) => total + title.value,
          0
        );
        setGenerateTitlesDialogMessage({
          quantityTitles: generate.length,
          totalValue: totalValue.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          }),
        });
        toggleDialog();
      } else {
        onShowAlert('danger', 'errors.title', 'notifications.select-title');
      }
    } else {
      onShowAlert('danger', 'errors.title', 'notifications.select-account');
    }
  };

  const validateLength = (checked) => {
    if (checked && discountConfigurations.length < 1) {
      onShowAlert(
        'warning',
        'warnings.title',
        'notifications.without-discount-configuration'
      );
      setApplyDiscountConfigurations(!applyDiscountConfigurations);
    }
  };

  useLayoutEffect(() => {
    if (discountConfigurations.length < 1) {
      dispatch(change('generatorTitle', 'applyDiscountConfiguration', false));
    }
  }, [applyDiscountConfigurations]);

  useLayoutEffect(() => {
    if (isSmartPay) {
      initialize(smartpayConfigurations);
    } else {
      initialize({});
    }
  }, [isSmartPay]);

  useEffect(() => {
    dispatch(change('generatorTitle', 'titles', data));
    dispatch(change('generatorTitle', 'dto', dto));
    dispatch(
      change('generatorTitle', 'discountConfigurations', discountConfigurations)
    );
  }, [data, isSmartPay, discountConfigurations]);

  useEffect(() => {
    setData(titles);
    if (smartpayConfigurations.account && dto.toGenerate) {
      loadDiscountConfigurationByAccount(smartpayConfigurations.account.id);
    }
    if (dto.toGenerate) {
      setHideDiscount(!hideDiscount);
      if (smartpayConfigurations.account) {
        setIsSmartpay(!isSmartPay);
      }
    } else if (
      !dto.toGenerate &&
      titles[0].id !== 0 &&
      titles[0].account.smartpay
    ) {
      setHideChecked(!hideChecked);
      setIsSmartpay(!isSmartPay);
    } else {
      setHideSelect(!hideSelect);
      setHideChecked(!hideChecked);
      setHideDiscount(!hideDiscount);
    }
    return () => {
      setData([]);
      setHideChecked(false);
      setHideDiscount(false);
    };
  }, []);

  return (
    <>
      <FullScreenDialog
        title={t('panels.discounts-setup')}
        toggleDialog={toggleDiscontConfigurationForm}
        isOpen={discontConfigurationForm}
        toggleBackDialog={toggleViewDiscount}
      >
        <DiscontConfigurationForm
          discountConfigurations={discountConfigurations}
          onConfirm={changeDiscountConfigurations}
          titleId={dto.id}
        />
      </FullScreenDialog>
      <FullScreenDialog
        title={t('panels.discounts-setup')}
        toggleDialog={toggleViewDiscount}
        isOpen={fullViewDiscount}
        toggleBackDialog={toggleViewDiscount}
      >
        <ViewDiscountComponent data={viewDiscount} />
      </FullScreenDialog>
      <Dialog
        className="m-2 align-items-end"
        style={{ bottom: 'auto' }}
        open={dialog}
      >
        <div
          className="modal-dialog--warning modal-alert d-flex flex-column justify-content-center"
          style={{ height: '16rem' }}
        >
          <div className="modal__header d-flex flex-column align-items-center">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggleDialog}
            />
            <span className="lnr lnr-flag modal__title-icon" />
            <h4 className="bold-text  modal__title">{t('warnings.title')}</h4>
          </div>
          <div className="modal__body text-center p-4">
            {t('general.generated')}
            {generateTitlesDialogMessage.quantityTitles}
            {t('general.titles-value-of')}
            {generateTitlesDialogMessage.totalValue}
            {t('general.to-continue')}
          </div>

          <ButtonToolbar className="modal__footer">
            <Button onClick={toggleDialog}>{t('general.cancel')}</Button>{' '}
            <Button
              color="warning"
              onClick={() => {
                toggleDialog();
                handleSubmit();
              }}
            >
              {t('general.confirm')}
            </Button>
          </ButtonToolbar>
        </div>
      </Dialog>
      <SmartCard>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.contract-number')}:
            </span>
            <span className="bold-text pl-1">{dto.numberContract}</span>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.student')}:
            </span>
            <span className="bold-text pl-1">{dto.student.fullName}</span>
          </div>
          <div className="form__form-group--3_columns">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.responsible-account')}:
              </span>
              <span className="bold-text pl-1">
                {dto.responsible1.responsible.fullName}
              </span>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.email')}:
              </span>
              <span className="bold-text pl-1">
                {dto.responsible1.responsible.email}
              </span>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.phone')}
              </span>
              <span className="bold-text pl-1">
                {dto.responsible1.responsible &&
                  dto.responsible1.responsible.cellPhone &&
                  formatPhone(dto.responsible1.responsible.cellPhone)}
              </span>
            </div>
          </div>
          {dto.toGenerate && smartpayConfigurations.account && (
            <div className="form__form-group">
              <div className="form__form-group-field">
                <span className="generic__label text-danger">
                  {t('screens.mnt_contratos.generate-billing')}
                </span>
                <Field
                  name="automaticBilling"
                  component={renderCheckBoxField}
                  className="colored-click"
                  onChange={(event) => {
                    if (event.target)
                      accountChecboxChange(event.target.checked);
                  }}
                />
              </div>
            </div>
          )}
          {loggedUser.login.toUpperCase() === SMART_BABY_USER &&
            dto.toGenerate && (
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <span className="generic__label text-danger">
                    {t('general.test-environment')}
                  </span>
                  <Field
                    name="inTestEnvironment"
                    component={renderCheckBoxField}
                    className="colored-click"
                  />
                </div>
              </div>
            )}
          {!hideSelect && (
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('general.account')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="account"
                  type="text"
                  component={Select}
                  isDisabled={isSmartPay}
                  options={accounts}
                  onChange={(values) => accountChange(values)}
                  placeholder={t('screens.mnt_contratos.placeholders.select')}
                />
              </div>
            </div>
          )}
          <Collapse isOpen={isSmartPay} className="width100">
            <div className="form__form-group--2_columns">
              <div className="form__form-group-field">
                <span className="form__form-group-label pr-2">
                  {t('account.penalty')}
                </span>
                <Field
                  name="fines"
                  component={renderCheckBoxField}
                  disabled={!dto.toGenerate}
                  className="colored-click"
                />
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('account.fine-amount')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="latePaymentFine"
                    type="text"
                    component={renderField}
                    disabled={!dto.toGenerate}
                    {...percentageMasker()}
                  />
                </div>
              </div>
            </div>
            <div className="form__form-group--2_columns">
              <div className="form__form-group-field">
                <span className="form__form-group-label pr-2">
                  {t('account.interest')}
                </span>
                <Field
                  name="perDayInterest"
                  component={renderCheckBoxField}
                  disabled={!dto.toGenerate}
                  className="colored-click"
                />
              </div>
              <div className="form__form-group--2_columns d-flex nowrap">
                <div className="form__form-group-field  ml-3">
                  <span className="form__form-group-label pr-2 text-nowrap">
                    {t('general.apply-discount')}
                  </span>
                  <Field
                    name="applyDiscountConfiguration"
                    component={renderCheckBoxField}
                    disabled={!dto.toGenerate}
                    className="colored-click"
                    onChange={(event) => {
                      if (event.target) {
                        validateLength(event.target.checked);
                      }
                    }}
                  />
                </div>
                <div className="form__form-group-field flex-1">
                  <Tooltip title={t('general.edit-discounts')}>
                    <IconButton
                      aria-label="edit"
                      disabled={!dto.toGenerate}
                      onClick={() => {
                        toggleDiscontConfigurationForm();
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </div>
            <Collapse
              isOpen={
                notificationAlert.status &&
                notificationAlert.color === 'warning'
              }
              className="w-100 text-center"
            >
              <Alert color={notificationAlert.color}>
                {t(notificationAlert.message)}
              </Alert>
            </Collapse>
          </Collapse>
          <div className="form__form-group d-flex justify-content-center card__title">
            <h5 className="bold-text">
              {dto.toGenerate
                ? t('general.select-generator-titles')
                : t('general.contract-titles')}
            </h5>
          </div>
          <MaterialTableThemeProvider>
            <div className="form__form-group">
              <MaterialTable
                data={data}
                icons={materialTableIcons}
                columns={columnsGenerate(
                  t,
                  onUpdateState,
                  categories,
                  onViewDiscount,
                  hideChecked,
                  hideDiscount
                )}
                onRowClick={(evt, rowData) => compositionTitleChange(rowData)}
                options={{
                  paging: false,
                  showTitle: false,
                  search: false,
                  toolbar: false,
                  headerStyle: {
                    zIndex: 0,
                  },
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: t(
                      'general.tables.no-data-to-display'
                    ),
                  },
                }}
              />
            </div>
          </MaterialTableThemeProvider>
          <div className="form__form-group d-flex justify-content-center card__title">
            <h5 className="bold-text">{t('general.title-composition')}</h5>
          </div>
          <MaterialTableThemeProvider>
            <div className="form__form-group">
              <MaterialTable
                data={compositionTitle}
                icons={materialTableIcons}
                columns={columnsComposition(t)}
                options={{
                  paging: false,
                  showTitle: false,
                  search: false,
                  toolbar: false,
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: t(
                      'general.tables.no-data-to-display'
                    ),
                  },
                }}
              />
            </div>
          </MaterialTableThemeProvider>
          <Collapse
            isOpen={
              notificationAlert.status && notificationAlert.color === 'danger'
            }
            className="w-100 text-center"
          >
            <Alert color={notificationAlert.color}>
              {t(notificationAlert.message)}
            </Alert>
          </Collapse>
          {dto.toGenerate && (
            <ButtonToolbar className="form__button-toolbar">
              <Button color="success" onClick={() => handleSubmitGenerate()}>
                {t('general.generator')}
              </Button>
            </ButtonToolbar>
          )}
        </form>
      </SmartCard>
    </>
  );
};

GeneratorTitles.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  titles: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  dispatch: PropTypes.func.isRequired,
  setDiscountConfigurations: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  discountConfigurations: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
  accounts: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  loadDiscountConfigurationByAccount: PropTypes.func.isRequired,
  smartpayConfigurations: PropTypes.shape(PropTypes.shape),
  handleSubmit: PropTypes.func.isRequired,
};

GeneratorTitles.defaultProps = {
  discountConfigurations: [],
  smartpayConfigurations: [],
};

export default reduxForm({
  form: 'generatorTitle',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(GeneratorTitles));
